import PropTypes from 'prop-types';
import React from 'react';
import { withTranslation } from 'react-i18next';
import { Tab, Tabs } from '@blueprintjs/core';

import StatByCorpus from './StatByCorpus';
import StatGlobal from './StatGlobal';
import { Tooltip2, Classes } from '@blueprintjs/popover2';


/* const extractRealSpec = (stats,subCorpora) => {
  var realSpec={};
  const realizations=Object.keys(stats.realizations).sort();
  for (var i=0;i<realizations.length;i++) {
    const realization=realizations[i];
    realSpec[realization]={};
    for (var j=0;j<subCorpora.length;j++) {
      const subCorpus=subCorpora[j];
      //console.log(realization+" "+subCorpus);
      if (stats.byCorpus[subCorpus]['realizations'][realization]) {
        realSpec[realization][subCorpus]=stats.byCorpus[subCorpus]['realizations'][realization]['spec'];
        //console.log(realization+" "+subCorpus+"="+toString(stats.byCorpus[subCorpus]['realizations'][realization]['spec']))
      }
    }
  }
  
  return realSpec;
} */


class Statistics extends React.PureComponent {

  state = {
    //selectedTabId: Object.keys(this.props.stats.byCorpus)[0],  // select first corpus by default
    selectedTabId:Object.keys(this.props.stats.byCorpus).length===1? Object.keys(this.props.stats.byCorpus)[0]:"Global"
  }

  handleTabChange = (navbarTabId) => {
    this.setState({ selectedTabId: navbarTabId });
    // this trick is to cope with the react-apex-chart show problem
    // cdhttps://github.com/apexcharts/vue-apexcharts/issues/185
    window.dispatchEvent(new Event('resize'));
 
  }

  
  render() {
    const { stats, t, subCorpora } = this.props;

    const tabs = [];

    // grouping realization specificities in a single hash
    // const realSpec=extractRealSpec(this.props.stats,subCorpora);

    // generate the global page, only when more than one page
    if (subCorpora.length > 1) {
      const stat = <StatGlobal 
                      corpusStats={this.props.stats} 
                      // realSpec={realSpec} 
                      query={this.props.query} 
                      querySvg={this.props.querySvg}
                      estimatedResults={this.props.estimatedResults["_global_"]}
                      pasteQuery={this.props.pasteQuery}
                      performSearch={this.props.performSearch}
                      runMLM={this.props.runMLM}
                    />;
      const tab = <Tab key='Global' id='Global' title={t('global')} panel={stat} />;
      tabs.push(tab);
    } else {
      // when there is only one page, some data should be copied from the global stats to the subCorpus
      stats.byCorpus[subCorpora[0]].realizations=stats.realizations;

    }

    // generate the indidual stat pages (sub-corpus or partition)
    
    let subCorp=subCorpora.filter(subCorpus=>stats.byCorpus[subCorpus].freq);
    const displayName=subCorp.length>16;
    
    for (var i=0;i<subCorpora.length;i++) {
      const subCorpus=subCorpora[i];

      if (stats.byCorpus[subCorpus].freq) {
        const title=(displayName) ? (" "+(i+1).toString()).slice(-2):subCorpus;

        // ci-dessous : on n'affiche pas la disp. s'il n'y a qu'un seul document
        const detailStats=Object.keys(stats.byCorpus[subCorpus].byDoc).length > 1 ? "specByDoc" : "freqByDoc";
        const stat =  <StatByCorpus 
                          name={subCorpus}
                          displayName={displayName}
                          corpusStats={stats.byCorpus[subCorpus]} 
                          //realSpec={realSpec} 
                          query={this.props.query}  
                          querySvg={this.props.querySvg}
                          detailStats={detailStats}
                          estimatedResults={this.props.estimatedResults[subCorpus]}
                          pasteQuery={this.props.pasteQuery}
                          performSearch={this.props.performSearch}
                          runMLM={this.props.runMLM}
                      />;
          const tab = <Tab key={subCorpus} id={subCorpus} title={title} panel={stat} >
                        {displayName && <Tooltip2 content={subCorpus} className={Classes.TOOLTIP2_INDICATOR} placement="bottom" >…</Tooltip2>}
                      </Tab>;
          tabs.push(tab);
      }
    }

    return (
      <>
        
        <Tabs onChange={this.handleTabChange} selectedTabId={this.state.selectedTabId} renderActiveTabPanelOnly >
          {tabs}
        </Tabs>
      </>
    );
  }
}

Statistics.propTypes = {
  subCorpora : PropTypes.array,
  stats: PropTypes.object,
  query: PropTypes.string,
  querySvg: PropTypes.string,
  estimatedResults: PropTypes.object,
  pasteQuery: PropTypes.func,
  performSearch: PropTypes.func
};

export default withTranslation()(Statistics);
